/**
* Check that the object has the required properties
*
* @param {*} obj - potential object being tested
* @param {...string} properties - required properties to an object has
* @returns {boolean}
*/
function hasRequiredProperties(obj, ...properties) {
  if (!isObject(obj)) {
      return false;
  }

  for (let i = 0, n = properties.length; i < n; i++) {
      if (!obj.hasOwnProperty(properties[i])) {
          return false;
      }
  }

  return true;
}

/**
* Determine if argument is an object
*
* @param {*} obj - potential object being tested
* @returns {boolean}
*/
function isObject(obj) {
  return typeof obj === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype ;
}

/**
 * Deep merge one or more source object into a target object and returns the modified target object
 * @param {object} target
 * @param  {...object} sources
 * @returns {object}
 */
function mergeDeep(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();

  if (isObject(target) && isObject(source)) {
      for (const key in source) {
        if (isObject(source[key])) {
          if (!target[key]) Object.assign(target, {
            [key]: {}
          });
          mergeDeep(target[key], source[key]);
        } else {
          let val = source[key];

          if (val !== null && typeof val !== 'undefined') { // don't override a present value with a missing one
            Object.assign(target, {
              [key]: val
            });
          }
        }
      }
    }

    return mergeDeep(target, ...sources);
  }

export {
  isObject,
  hasRequiredProperties,
  mergeDeep,
};
